import React from 'react';
import styles from './BrandNot.module.scss';

const BrandNot = () => {
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>
        Бренды, которые не&nbsp;могут
        <br />
        участвовать в&nbsp;программе
      </h3>
      <ul className={styles.list}>
        <li>Табачные изделия и никотиносодержащая продукция, принадлежности, предназначенные для их&nbsp;курения.</li>
        <li>Оружие, основные части огнестрельного оружия, патроны.</li>
        <li>
          Товары, указанные в&nbsp;
          <a
            className={styles.link}
            href="http://government.ru/docs/all/116179/"
            target="_blank"
            rel="noreferer noreferrer">
            перечне кодов видов сырьевых товаров в&nbsp;соответствии с&nbsp;единой Товарной номенклатурой
            внешнеэкономической деятельности
          </a>
          , утвержденной постановлением Правительства Российской&nbsp;Федерации от&nbsp;18.04.2018&nbsp;№&nbsp;466.
        </li>
      </ul>
    </div>
  );
};

export default BrandNot;
